import { render, staticRenderFns } from "./OrderItems.vue?vue&type=template&id=3203dc62&scoped=true&"
import script from "./OrderItems.vue?vue&type=script&lang=js&"
export * from "./OrderItems.vue?vue&type=script&lang=js&"
import style0 from "./OrderItems.vue?vue&type=style&index=0&id=3203dc62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3203dc62",
  null
  
)

export default component.exports